var templates = require.context('.', true, /\.html$/);
templates.keys().forEach(function (key) {
    templates(key);
});

import queryFactory from "./angular.query.service";
import dexieQuery from "./dexie.query";
import queryLogic from "./query_logic.directive";
import queryUi from "./query_ui.directive";
import queryField from "./query_field.directive";

const MODULE_NAME = 'ocom.query';

angular.module(MODULE_NAME, [])
    .factory("queryFactory", queryFactory)
    .factory("dexieQuery", dexieQuery)
    .directive("queryField", queryField)
    .directive("queryLogic", queryLogic)
    .directive("queryUi", queryUi);

export default MODULE_NAME;